import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Angulartics2 } from 'angulartics2';
import { Meta } from '@angular/platform-browser';
import { SeoService } from '../common/services/seo.service';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {
  textData = {
    general: {
      title: 'Jocuri biblice și activități',
      description1: 'Cu noi, niciodată nu rămâi fără idei!',
      description2: 'Cu ajutorul nostru, copiii vor învăța lucruri interesante despre Dumnezeu într-un mod inedit!',
      button: 'Adio plictiseală!'
    },
    activities: {
      title: 'Jocuri biblice și activități online și offline',
      button: 'INTRĂ SĂ VEZI JOCURILE'
    },
    coloring: {
      title: 'Planșe de colorat pe diverse teme biblice',
      button: 'INTRĂ SĂ VEZI PLANȘELE'
    },
    cartoons: {
      title: 'Desene animate crestine',
      button: 'INTRĂ SĂ VEZI DESENELE'
    },
    songs: {
      title: 'Cântece creștine pentru copii',
      button: 'INTRĂ SĂ ASCULȚI CÂNTECELE'
    },
    reviews: {
      title: 'Recenzii de cărți și jocuri biblice online și offline',
      button: 'INTRĂ SĂ VEZI RECENZIILE'
    }
  };

  constructor(
    private titleService: Title,
    private angulartics2: Angulartics2,
    private meta: Meta,
    private seoService: SeoService
  ) {
    this.seoService.setTitle('FunBible - Jocuri biblice, desene animate crestine, planse de colorat si multe altele');
    this.seoService.setDescription('Jocuri biblice, desene animate crestine, recenzii la produse crestine pentru copii, planse de colorat pe teme biblice si multe surprize');
    this.meta.updateTag({ property: 'og:image', content: 'https://funbible.net/assets/logo.jpg' });
    this.meta.updateTag({ property: 'og:url', content: 'https://funbible.net/home/' });
    const initialKeywords = ['jocuri biblice', 'jocuri de copii', 'jocuri ptr copii', 'jocuri online copii', 'desene animate crestine', 'muzica pt copi', 'desene animate crestine', 'filme animate biblice', 'planse de colorat', 'fisa de colorat'].join();
    this.meta.updateTag({property: 'keywords', content: initialKeywords});
    this.angulartics2.eventTrack.next({
      action: 'Home',
      properties: { category: 'pageView' },
    });
  }

  ngOnInit() {
  }

}
